import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';

const logo = '/assets/logos/horizontal logo for dark bg.png';
const logo3= '/assets/logos/horizontal logo for light bg.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container-standard px-4 flex justify-between items-center">
        <motion.div
          className="flex items-center overflow-hidden h-24"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
            <Link to="/">
            <img
              src={scrolled || ['servicios', 'proyectos', 'noticias', 'clientes', 'contacto'].some(path => location.pathname.includes(path)) ? logo3 : logo}
              alt="DavidCorp S.R.L."
              className="h-52 object-contain"
            />
            </Link>
        </motion.div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8">
          <Link
            to="/"
            className={`font-medium transition-colors ${
              location.pathname === '/' ? 'text-accent-500' : 'text-primary-300 hover:text-accent-500'
            }`}
          >
            Inicio
          </Link>
          <Link
            to="/nosotros"
            className={`font-medium transition-colors ${
              location.pathname === '/nosotros' ? 'text-accent-500' : 'text-primary-300 hover:text-accent-500'
            }`}
          >
            Nosotros
          </Link>
          <Link
            to="/servicios"
            className={`font-medium transition-colors ${
              location.pathname === '/servicios' ? 'text-accent-500' : 'text-primary-300 hover:text-accent-500'
            }`}
          >
            Servicios
          </Link>
          <Link
            to="/proyectos"
            className={`font-medium transition-colors ${
              location.pathname === '/proyectos' ? 'text-accent-500' : 'text-primary-300 hover:text-accent-500'
            }`}
          >
            Proyectos
          </Link>
          <Link
            to="/noticias"
            className={`font-medium transition-colors ${
              location.pathname === '/noticias' ? 'text-accent-500' : 'text-primary-300 hover:text-accent-500'
            }`}
          >
            Noticias
          </Link>
          <Link
            to="/clientes"
            className={`font-medium transition-colors ${
              location.pathname === '/clientes' ? 'text-accent-500' : 'text-primary-300 hover:text-accent-500'
            }`}
          >
            Clientes
          </Link>
          <Link
            to="/contacto"
            className={`font-medium transition-colors ${
              location.pathname === '/contacto' ? 'text-accent-500' : 'text-primary-300 hover:text-accent-500'
            }`}
          >
            Contacto
          </Link>
        </nav>

        {/* Mobile Menu Button */}
        <div className="px-2 md:hidden flex items-center">
          <button
            onClick={toggleMenu}
            className="text-primary-300 focus:outline-none"
          >
            <svg
              className="w-8 h-8"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            className="md:hidden bg-white shadow-xl"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
          >
            <div className="container-standard px-4 py-4 flex flex-col space-y-4">
              <Link
                to="/"
                className={`py-2 text-primary-500 font-medium transition-colors ${
                  location.pathname === '/' ? 'text-accent-500' : 'hover:text-accent-500'
                }`}
                onClick={closeMenu}
              >
                Inicio
              </Link>
              <Link
                to="/nosotros"
                className={`py-2 text-primary-500 font-medium transition-colors ${
                  location.pathname === '/nosotros' ? 'text-accent-500' : 'hover:text-accent-500'
                }`}
                onClick={closeMenu}
              >
                Nosotros
              </Link>
              <Link
                to="/servicios"
                className={`py-2 text-primary-500 font-medium transition-colors ${
                  location.pathname === '/servicios' ? 'text-accent-500' : 'hover:text-accent-500'
                }`}
                onClick={closeMenu}
              >
                Servicios
              </Link>
              <Link
                to="/proyectos"
                className={`py-2 text-primary-500 font-medium transition-colors ${
                  location.pathname === '/proyectos' ? 'text-accent-500' : 'hover:text-accent-500'
                }`}
                onClick={closeMenu}
              >
                Proyectos
              </Link>
              <Link
                to="/noticias"
                className={`py-2 text-primary-500 font-medium transition-colors ${
                  location.pathname === '/noticias' ? 'text-accent-500' : 'hover:text-accent-500'
                }`}
                onClick={closeMenu}
              >
                Noticias
              </Link>
              <Link
                to="/clientes"
                className={`py-2 text-primary-500 font-medium transition-colors ${
                  location.pathname === '/clientes' ? 'text-accent-500' : 'hover:text-accent-500'
                }`}
                onClick={closeMenu}
              >
                Clientes
              </Link>
              <Link
                to="/contacto"
                className={`py-2 text-primary-500 font-medium transition-colors ${
                  location.pathname === '/contacto' ? 'text-accent-500' : 'hover:text-accent-500'
                }`}
                onClick={closeMenu}
              >
                Contacto
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
